import { Typography } from "@mui/material";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer>
      <Typography fontSize={14}>{`© ${year} Dreamie Planner. All Rights Reserved.`}</Typography>
    </footer>
  )
}

export default Footer;